import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Transition } from 'react-transition-group'

import ButtonCircle from 'components/ButtonCircle'

import { Cover, ButtonWrapper, StyledYouTube, Wrapper } from './styles'

const ANIMATION_DUR = 300

/**
 * Component that wraps youtube player
 *
 * @returns { YouTubePlayer } YouTubePlayer
 */
export default class YouTubePlayer extends Component {
  static propTypes = {
    /** Url of an image to use it as cover */
    cover: PropTypes.string.isRequired,

    /** Id of an youtube video */
    videoId: PropTypes.string.isRequired,

    /** Class for wrapper */
    className: PropTypes.string,

    /** Content for this video block */
    content: PropTypes.object,
  }

  static defaultProps = {
    className: '',
  }

  constructor(props) {
    super(props)

    this.player = null

    this.state = {
      isPlay: false,
    }
  }

  /**
   * Handler for youtube player's state changes
   *
   * @param {object} event - you tube api event object
   * @returns {void}
   */
  handlePlayerStateChange = event => {
    if (event.data === YT.PlayerState.PLAYING) {
      this.handleStart()
    }
    if (event.data === YT.PlayerState.ENDED) {
      this.handleStop()
    }
  }

  handleStart = () => {
    this.setState({
      isPlay: true,
    })
    this.player?.playVideo()
  }

  handleStop = () => {
    this.setState({
      isPlay: false,
    })
  }

  handleReady = event => {
    this.player = event.target
  }

  render() {
    const { videoId, cover, className, content } = this.props
    const { isPlay } = this.state

    return (
      <Wrapper className={className}>
        {process.browser && (
          <StyledYouTube
            content={content}
            isPlay={isPlay}
            videoId={videoId}
            containerClassName={'h-100'}
            onStateChange={this.handlePlayerStateChange}
            onReady={this.handleReady}
          />
        )}
        <Transition in={!isPlay} timeout={ANIMATION_DUR}>
          {state => (
            <Cover state={state} withContent={!!content} cover={cover}>
              {content}
              <div className="col text-center">
                <ButtonWrapper>
                  <ButtonCircle
                    size="large"
                    as="button"
                    bgClassName="bg--white"
                    blackoutClassName="bg--white"
                    textClassName="text"
                    icon="btn_play"
                    iconColor="black"
                    wrapperProps={{
                      onClick: this.handleStart,
                    }}
                  />
                </ButtonWrapper>
              </div>
              <div className="col d-none d-md-block" />
            </Cover>
          )}
        </Transition>
      </Wrapper>
    )
  }
}
